import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, concatMap, map, mergeMap, switchMap, withLatestFrom } from "rxjs/operators";

import { DealerActions } from "../actions/dealer.actions";

import { BuyActions } from "../actions/buy.actions";
import { Proposal } from "src/app/public/buy/models/proposal.model";
import { BuyService } from "src/app/public/buy/services/buy.service";



@Injectable()
export class BuyApiEffects{

    constructor(
        private buyService: BuyService,
        private actions$: Actions
    ){}

    addNewProposal$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(BuyActions.proposalNewSubmit),
            concatMap( (action) => {
                return this.buyService
                    .addNewProposal (action.proposal)
                    .pipe( 
                        map( (result: Proposal) => { 
                            //if(carCriteria !== null)
                                return BuyActions.proposalUpsertSuccess ( { proposal: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    /*
    updateProposal$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(BuyActions.proposalUpdateSubmit),
            concatMap( (action) => {
                return this.buyService
                    .updateProposal (action.proposal)
                    .pipe( 
                        map( (result: Proposal) => { 
                            
                                return BuyActions.proposalUpsertSuccess ( { proposal: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    */

    executeProposalAction$ = createEffect( () => {
            return this.actions$.pipe(
                ofType(BuyActions.proposalActionSubmit),
                concatMap( (action) => {
                    return this.buyService
                        .executeProposalAction (action.proposalAction, action.proposal)
                        .pipe( 
                            map( (result: Proposal) => { 
                                
                                    return BuyActions.proposalUpsertSuccess ( { proposal: result, objectSource: action.objectSource } );
                                })
                            )
                })
            )
        });

    updateProposalStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(BuyActions.proposalStatusUpdateSubmit),
            concatMap( (action) => {
                return this.buyService
                    .updateProposalStatus (action.proposalId, action.status)
                    .pipe( 
                        map( (result: Proposal) => { 
                            
                                return BuyActions.proposalUpsertSuccess ( { proposal: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    rescheduleProposal$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(BuyActions.proposalRescheduleSubmit),
            concatMap( (action) => {
                return this.buyService
                    .rescheduleProposal (action.proposalId, action.rescDate)
                    .pipe( 
                        map( (result: Proposal) => { 
                            
                                return BuyActions.proposalUpsertSuccess( { proposal: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    createNewCarOffer$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(DealerActions.createNewCarOfferSubmit),
            concatMap( (action) => {
                return this.buyService
                    .createNewOffer (action.carId, action.amount)
                    .pipe( 
                        map( (res: any) => { 
                            return DealerActions.createNewCarOfferSuccess( {carId: action.carId, offer: res } );
                            })
                        )
            })
        )
    });
}